import { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { MEMBER_QUESTIONS_NO_DATA } from "./GetMemberDetails";
import dal from "../middleware/DAL";

export async function GetMemberQuestions() {
  try {
    const path = environment.BASE_URL + "MemberRegister/GetMemberQuestions";
    const res: AxiosResponse<any> = await dal.post(path, {});
    if (axiosUtil.isSuccess(res) && res?.data?.dataRows?.length) {
      const memberQuestions = res.data.dataRows;
      return memberQuestions;
    }
    // handle member no questions data
    if (res?.data?.errorCode === 52) return MEMBER_QUESTIONS_NO_DATA;

    return [];
  } catch (err) {
    console.log(err);
  }
}
